export interface ServiceCallsResponse {
    nextPage: string;
    totalCount: number;
    filteredCount: number;
    filterHTML: string;
    debug: number;
    messages: ServiceCallMessages;
    items: ServiceCallItem[] | null;
}

export interface ServiceCallItem {
    notificationType: string;
    fullMachineName: string | null;
    status: ServiceCallStatus | null;
    sisCaseId: string;
    detailLink: string;
    lastUpdateFromSis: string;
    creationDate: string;
    createdByUser: string;
    description: string;
    /** @deprecated status type should be handled by the BE */
    unreadChatMessages: number;
}

export interface ServiceCallMessages {
    /** @deprecated */
    unreadChatMessagesText: string;
}

export interface ServiceCallStatus {
    type: ServiceCallStatusType;
    text: string;
}

export enum ServiceCallStatusType {
    TransactionFailed = "TransactionFailed",
    Open = "Open",
    Deleted = "Deleted",
    Closed = "Closed",
    WaitingForCustomer = "WaitingForCustomer",
    InProcess = "InProcess",
    CallPredictive = "call-predictive",
    /** @deprecated use UnreadChatMessages type */
    NewMessage = "NewTechMessage",
    UnreadChatMessages = "UnreadChatMessages",
    OrderNumberRequired = "OrderNumberRequired",
}
